import React from 'react';
import styled from 'styled-components';
import InfoIcon from '@mui/icons-material/Info';

const StyledInfoICon = styled(InfoIcon)`
    &&{
      display: inline-block;
      cursor: pointer;
      transition: .5s;
      font-size: 1.2857142857142856rem;
      
      &:hover {
        color: #3F51B5;
      }
      }
    `;


export default function TooltipInfoButtonContainer (props) {
    return (
        <StyledInfoICon onMouseOver={props.onMouseOver} onMouseLeave={props.onMouseLeave}/>
    );
}